import React from "react";
import { formatDateForDisplay } from "utils/dateUtils";
import { Typography, useTheme } from "@mui/material";

interface CellDateProps {
  params: any;
  onClick?: () => void;
}

const CellDate = ({ params, onClick }: CellDateProps) => {
  const theme = useTheme();
  const isoDate = params?.value;
  const formattedDate = isoDate
    ? formatDateForDisplay(isoDate, "dd LLL yyyy")
    : "--";

  return (
    <Typography
      component="span"
      sx={{
        fontSize: "14px",
        color: theme.palette.text.primary,
        cursor: onClick ? "pointer" : "default",
      }}
      onClick={onClick}
    >
      {formattedDate}
    </Typography>
  );
};

export default CellDate;
